import type { DatovkaApiType } from '@gov-nx/api';
import { useDataBoxStoreLists } from '@gov-nx/store';
import { hasCommonValue } from '@gov-nx/utils/common';

export interface DataBoxAccessProps {
	requiredTypes?: DatovkaApiType['typSchranky'][];
}

export const useDataBoxAccess = (
	{ requiredTypes }: DataBoxAccessProps = { requiredTypes: [] }
) => {
	const areRequiredTypes = !!(
		Array.isArray(requiredTypes) && requiredTypes.length
	);

	const {
		list,
		connectedDataBoxes,
		disconnectedDataBoxes,
		connectedDataBoxesIds,
		dataBoxesToConnect,
		dataBoxesToCreate,
	} = useDataBoxStoreLists();

	const connectedTypes = connectedDataBoxes.map(
		(dataBox) => dataBox.typSchranky
	);
	const disconnectedTypes = disconnectedDataBoxes.map(
		(dataBox) => dataBox.typSchranky
	);
	const listToConnectTypes = dataBoxesToConnect.map(
		(dataBox) => dataBox.typSchranky
	);
	const listToCreateTypes = dataBoxesToCreate.map(
		(dataBox) => dataBox.typSchranky
	);

	const possibleToConnect = areRequiredTypes
		? hasCommonValue(requiredTypes, listToConnectTypes)
		: !!listToConnectTypes.length;
	const possibleToCreate = areRequiredTypes
		? hasCommonValue(requiredTypes, listToCreateTypes)
		: !!listToCreateTypes.length;
	const possibleToConnectOrCreate = possibleToConnect || possibleToCreate;
	const areAnyConnected = areRequiredTypes
		? hasCommonValue(requiredTypes, connectedTypes)
		: !!connectedTypes.length;

	return {
		list,
		connectedList: connectedDataBoxes,
		connectedIds: connectedDataBoxesIds,
		disconnectedList: disconnectedDataBoxes,
		listToConnect: dataBoxesToConnect,
		connectedTypes,
		disconnectedTypes,
		listToConnectTypes,
		listToCreateTypes,
		possibleToConnect,
		possibleToCreate,
		possibleToConnectOrCreate,
		areAnyConnected,
	};
};
